export default "__VITE_ASSET__MPhMmB0$__"